import React, { useState, useEffect, useContext } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import axios from 'axios'
import './index.css'
import Header from '../Header'
import Loading from '../LoadingComponent'
import Confirmation from '../ConfirmationComponent'
import { getHostName } from '../../base.js'
import { Button } from '@material-ui/core'
import COLORS  from '../../colors'
import { ReactComponent as  Kvacica} from '../../assets/kvacica.svg'
import { ReactComponent as  Info} from '../../assets/info.svg'
import { ReactComponent as  Share} from '../../assets/ic_share_ios.svg'

const GenerateQR = ({ processed, message, amount, creds, cartItems, prevPage, transactionList }) => {
	const [billId, ] = useState("KEKSPOS-" + Date.now())
	const [imagee, setImagee] = useState('')
	const [isTimeout, setIsTimeout] = useState(false)
	const { resetCart, setPageNumber, setTransactionList, setQrUrl, setQrImage, setProcessed, setMessage, signOut } = useContext(AuthContext) 
  	const [ popup, setPopup ] = useState(false)
	const [ isLoading, setIsLoading ] = useState(true)
	const [timeLeft, setTimeLeft] = useState(10 * 60) // 10 minutes in seconds
	const params = useParams()
	const navigate = useNavigate()
	const POLL_INTERVAL = 5000;
	const TIMEOUT =  10 * 60 * 1000; 
	const startTime = Date.now();


	useEffect(() => {
		const intervalId = setInterval(async () => {
			try {
				if (Date.now() - startTime > TIMEOUT) {
					clearInterval(intervalId);
					setPopup(false)
					setMessage("Plaćanje putem ovog ekrana više nije moguće.\nAko je QR kod podijeljen putem drugog kanala, provjerite status u Povijesti transakcija.")
					setProcessed(false)
					togglePopup()
					setImagee('')
					setQrImage(null)
					setQrUrl(null)
					resetCart()
					clearInterval(intervalId)
					setIsTimeout(true)
					return
				}

				const response = await axios.post(getHostName() + '/trx_status', {
					bill_id: billId,
					tid: creds.tid,
					token: creds.token
				});
			  
				const data = response.data;
			  
				if (data && data.resultCode === -2) {
				console.log('Transaction not found, polling...');
				return;
				}
		
				if (data && data.resultCode === 0) {
					if (data.result.accepted) {
						var item = {}
						item.keksId = parseInt(data.result.keksId)
						item.epochtime = Date.now()
						item.amount = parseFloat(parseFloat(data.result.amount).toFixed(2))
						item.amountVoided = data.result.amountVoided;
						item.articles = data.result.articles
						item.billId = data.result.billId
						console.log(item)
						var transactionArr = transactionList
						transactionArr.unshift(item)
						setProcessed(true)
						setTransactionList(transactionArr)
						setPopup(true)
					} else {
						setMessage("Transakcija nije uspješno obavljena.")
						setProcessed(false)
						setPopup(true)
					}
					resetCart()
					setImagee('')
					setQrImage(null)
					setQrUrl(null)
					clearInterval(intervalId)
				}
		  	} catch (err) {
				clearInterval(intervalId);
				setPopup(false)
				setMessage("Dogodila se greška pri provjeri stanja transakcije.")
				setProcessed(false)
				togglePopup()
				setImagee('')
				setQrImage(null)
				setQrUrl(null)
				resetCart()
		  	}
		}, POLL_INTERVAL);
	
		return () => clearInterval(intervalId); // cleanup on unmount
	},[billId]);
	
	const handleConfirmation = () => {
		setPopup(false)
	}

	useEffect(() => {
		generateQrImage().then(apiImage => {
		  setTimeout(() => setIsLoading(false), 1000)
		  let reader = new window.FileReader();
		  reader.readAsDataURL(apiImage);
		  reader.onload = function () {
			let imageDataUrl = reader.result;
			setImagee(imageDataUrl)
			setQrImage(imageDataUrl)

		  }
		})
	}, [billId])

	useEffect(() => 
	{ 
  		//window.addEventListener('popstate', onBackButtonEvent)
		window.onpopstate = function(e)
		{
			e.preventDefault()
			window.setTimeout(function () {
					setPageNumber(prevPage)
					if(prevPage===1){
						navigate(`/kekspos/${params.tid}/qr-iznos`)
					}else{
						navigate(`/kekspos/${params.tid}/kosarica`)
					}
					//window.location = getHostName() + `/kekspos/?cid=${cid}`
			}, 0)

			window.onpopstate=null

			//return "Data will be lost if you leave the page, are you sure?";

		}
		
	}, [])

	useEffect(() => 
	{   
		const handleReload = async (e) => 
		{
			e.preventDefault()
			signOut(creds.cid)
			setTimeout(() => window.location.assign(`/kekspos`, 0));
			window.removeEventListener('beforeunload', handleReload) 		
			return false
		}

		window.addEventListener("beforeunload", handleReload)
	   
		return () => 
		{    
			window.removeEventListener('beforeunload', handleReload) 
		}

	},[])

	useEffect(() => {
		if (!isLoading && timeLeft > 0) {
			const timer = setInterval(() => {
				setTimeLeft(prev => prev - 1)
			}, 1000)
			return () => clearInterval(timer)
		}
	}, [isLoading, timeLeft])

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60)
		const remainingSeconds = seconds % 60
		return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
	}

  	const getDefaultQrValues = () => {
    	var cid = creds.cid;
    	var tid = creds.tid;
    	var store = creds.store;
		var cashier_id = creds.cashier_id
    	var obj;
    	if (typeof cid === 'undefined' || typeof tid === 'undefined' || typeof store === 'undefined') {
				if(cartItems.length===0){
        				obj = {amount: amount}
				}else{
						obj = {amount: amount, cartItems}
				}
		} else {

			if(cartItems.length===0){
				obj = {
					qr_type: 4,
					cid: cid,
					tid: tid,
					store: store,
					cashier_id: cashier_id,
					amount: amount,
					currency: 'EUR',
					bill_id: billId
				}

			}else{
				obj = {
					qr_type: 4,
					cid: cid,
					tid: tid,
					store: store,
					cashier_id: cashier_id,
					amount: amount,
					cart: cartItems,
					currency: 'EUR',
					bill_id: billId
				}
			}
        	
		}
    	return obj;
    }

	const togglePopup = () => {
		setPopup(popup => !popup)
	}

  	const generateQrImage = async () => {

		let qrValues = getDefaultQrValues()
		return await axios({
			method: "get",
			responseType: "blob",
			url: getHostName() + `/generate_qr?height=350&width=350&data=${encodeURIComponent(JSON.stringify(qrValues))}`
	  	}).then(response => {
				setQrUrl(getHostName() + `/generate_qr?height=350&width=350&data=${encodeURIComponent(JSON.stringify(qrValues))}`)
				return response.data
	  	}).catch(error => {
				console.log("Error happend while creating qr code...")
		})

	}

 
  if(!popup&&!isLoading){
  	return (
    	<div className="generate-qr">
    	  <Header pageNumber={2} prevPage={prevPage} />
    	    <div className="generate-qr-body">
			 	<div className="generate-qr-title">
					<Kvacica />
					<div className="generate-qr-title-txt">Uspješno je kreiran QR kod za naplatu!</div>
				</div>
    			{imagee!==''&&<img src={imagee} style={{ width:'20rem', height:'20rem' }} alt='my-qr-code'/>}
				{timeLeft > 0 && (
					<div style={{ 
						marginTop: '1rem', 
						fontSize: '1.2rem', 
						color: timeLeft <= 60 ? '#ff4444' : '#666',
						fontWeight: 'bold'
					}}>
						Preostalo vrijeme: {formatTime(timeLeft)}
					</div>
				)}
				<div style={{paddingTop:'0.8rem', paddingBottom:'0.8rem'}}><Info/></div>
				<div className="generate-qr-txt"><span>Kreirani QR kod</span> na Vašem mobitelu pokažite KEKS Pay korisniku tj. vašem klijentu koji će gornji QR kod skenirati svojom KEKS Pay aplikacijom.</div>
	  			{imagee!==''&&<Button 	size="large"
										variant="contained"	 
										style={{ 	width:'300px',
						                       		textAlign:'center',
											   		justifyContent:'center',
						                       		color:"#fff",
											   		fontWeight:'bold',
											   		backgroundColor: COLORS.blue,
											   		margin:5,
						                       		textTransform:'none',
													textDecoration:'none',
													"&:hover": {
														backgroundColor:COLORS.blue
													} 
	   									}}
										component={Link}
										to={`/kekspos/${params.tid}/podijeli-qr-kod`}
										startIcon={<Share style={{marginLeft:-15, marginBottom:6}}/>} 
					               	 	onClick={() => setPageNumber(16) }
		  		               >PODIJELI QR KOD I ZAVRŠI</Button>}
	  	     </div>
   		</div>
  	)
}else if(popup&&!isLoading){
	return(
		<Confirmation cid={creds.cid}
			processed={processed}
			message={message}
			pageNumber={2}
			prevPage={prevPage}
			onConfirmation={() => handleConfirmation()}
			timeout={isTimeout} />
		)
	}
else{
	return(
		<Loading />
	)
}
}
 

export default GenerateQR
